import { render, staticRenderFns } from "./EditNotification.vue?vue&type=template&id=3e4dd8f2&scoped=true&"
import script from "./EditNotification.vue?vue&type=script&lang=js&"
export * from "./EditNotification.vue?vue&type=script&lang=js&"
import style0 from "./EditNotification.vue?vue&type=style&index=0&id=3e4dd8f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4dd8f2",
  null
  
)

export default component.exports